<template>
  <img class="img-icon" :src="require(`../../assets/icons/${this.name}.svg`)" />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.img-icon {
  vertical-align: middle;
  max-width: 20px;
  max-height: 20px;
}
</style>
